// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const DeleteGroupDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-deletegroupdialogcontainer" */ "./DeleteGroupDialogContainer")).then((bundle)=>{
        return {
            default: bundle.DeleteGroupDialogContainer
        };
    });
export const LazyDeleteGroupDialogContainer = /*#__PURE__*/ lazy(DeleteGroupDialogContainerLazyLoader);
